import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import Required from './Required';

const paddings = {
  xs: 'px-4 py-2',
  sm: 'px-10 py-6',
  md: 'px-12 py-10',
  lg: 'px-16 py-12',
};

export default function TextInput({
  label,
  value,
  onChange,
  multiline,
  required,
  error,
  padding = 'md',
  inputProps = {},
  className,
  ...props
}) {
  const effectiveMaxLength = props.maxLength ?? inputProps?.maxLength;

  function handleChange(e) {
    const newValue = e.target.value;
    if (!effectiveMaxLength || effectiveMaxLength >= newValue.length) onChange(newValue);
  }

  const propClasses = className ? className.split(' ') : [];
  const boxClasses = ['flex', 'flex-col', 'gap-4', ...propClasses].join(' ');

  return (
    <Box className={boxClasses}>
      {label && (
        <Typography component="label" className="block font-500">
          {label}
          {required && <Required />}
        </Typography>
      )}
      <Box
        className={clsx(
          paddings[padding],
          'border-1',
          'rounded-4',
          'flex',
          'gap-6',
          'items-center',
          { 'bg-neutral-100': props.disabled },
          { 'border-typography-danger': error },
          { 'border-neutral-300': !error }
        )}
      >
        {!multiline && (
          <input
            className="bg-transparent outline-0 text-14 w-full placeholder:text-typography-thirty disabled:text-typography-thirty disabled:bg-neutral-100"
            {...inputProps}
            {...props}
            value={value}
            onChange={handleChange}
          />
        )}
        {multiline && (
          <textarea
            className="bg-transparent outline-0 text-14 w-full placeholder:text-typography-thirty disabled:text-typography-thirty disabled:bg-neutral-100"
            rows={props.rows || 5}
            {...inputProps}
            {...props}
            value={value}
            onChange={handleChange}
          />
        )}
      </Box>
      {error && <Typography className="text-12 text-typography-danger">{error}</Typography>}
      {typeof effectiveMaxLength === 'number' && (
        <Box className="w-full text-right f-600 text-10 text-typography-thirty">
          {value?.length || 0} / {effectiveMaxLength}
        </Box>
      )}
    </Box>
  );
}
